<template>
	<div id="publicSiderbar">
		<div class='publicSiderbar_c'>
			<div class='title_c'>
				<div class='title'>
					快速切换
				</div>
				<div class='searchInput'>
					<el-input placeholder="请输入内容" v-model="input2" size='mini' clearable @input='handleSearch'>
	                    <!-- <i slot="suffix" class="el-icon-search searchTableData" ></i> -->
	                </el-input>
				</div>
			</div>
			<!-- 搜索内容 -->
			<div class='content_c'>
				<el-scrollbar class="default-scrollbar" style='height: 100%;'>
					<ul class="subjectTree">
						<li class='tree_item' v-for='i in auxiliaryDatass' :key='i.id' :class='{active_plublicS:nowTab===i.id}'
							@click='handleItemClick(i)'>
							<i class='colorStyle'></i>{{i.code + '&nbsp&nbsp' +i.name}}
						</li>
					</ul>
				</el-scrollbar>
			</div>
			
		</div>
	</div>
</template>

<script>
export default {
	props:{
		auxiliaryData:Array
	},
	data () {
		return {
			nowTab: '',
			subjectTypeList: [],
			datas: {},
			input2:"",
			auxiliaryDatas:[],
			auxiliaryDatass:[]
		}
	},
	computed:{
		
	},
	created(){
		this.getSubjectType();
	},
	methods: {
		handleSearch(e) {
			this.auxiliaryDatass = this.auxiliaryDatas.filter(i=>{
				 if((i.code+i.name).indexOf(e)>=0){
					return i;
				}
			})
			if(e==="") {
				this.auxiliaryDatass = this.auxiliaryDatas;
			}
		},
		// 树点击事件
		handleItemClick(i) {
			if(this.nowTab === i.id) return;
			this.nowTab = i.id;
			this.$emit('calbackId',i.id);
		},
		// 根据类别获取科目树
		getSubjectByType(type,i) {
			if (!this.datas[`subject_${i}`]) {
				try {
					this.$http.post('subject/ajaxgetTree' , {type:type}).then(res=>{
						
						this.$set(this.datas, `subject_${i}`, res.data.data);
					})
				}catch(e) {

				}
			}
		},
		// 获取科目类别
		getSubjectType() {
			try {
				this.$http.post('subject/getSubjectType' , {}).then(res=>{
					if(res) {
						this.subjectTypeList = res.data.data;
						this.nowTab = res.data.data[0];
						this.getSubjectByType(this.nowTab, '0');
						this.$emit('getSubjectType' , res.data.data);
					}
				})
			}catch(e) {
				console.log(e)
			}
		},
		// 渲染科目树 编码+名称
		renderContent (h, { node, data, store }) {
			return (
				<span class="custom-tree-node">
		            <span>{data.code} {data.name}</span>
	          	</span>);
		},
		// 科目选择
		handleNodeClick (data) {
			this.$emit('onHandleSubjectIdChange', data);
		},

	},
	watch:{
		auxiliaryData(val) {
			val.length&&(this.nowTab = val[0].id);
			val.length&&this.$emit('calbackId',val[0].id);
			this.auxiliaryDatas = val?JSON.parse(JSON.stringify(val)):[];
			this.auxiliaryDatass = val?JSON.parse(JSON.stringify(val)):[];
		}
	}
}
</script>
<style lang='less'>
	#publicSiderbar {
		max-width: 320px;
		height: 100%;
		width: 100%;
		border-radius: 5px;
		display: inline-block;
		border:1px solid #eee;
		.publicSiderbar_c {
			height: 100%;
			position: relative;
			overflow: hidden;
			.title_c {
				padding: 10px 20px 20px;
				border-bottom:1px solid #eee;
				position: absolute;
				top: 0;
				right: 0;
				left: 0;
				.title {
					text-align: left;
					color: #333;
					font-weight: 600;
					margin-bottom: 10px;
				}

			}
			.content_c {
				height: calc(100% - 100px);
				margin-top: 100px;
				.subjectTree {
					.tree_item {
						padding: 5px 20px;
						text-align: left;
						color: #666;
						position: relative;
						cursor: pointer;
						&:hover {
							background-color:#deefea;
							color: #333; 
						};
					}
					.active_plublicS {
						border-left: solid 3px #20BD90;
						background-color:#deefea;
						color: #333; 
					}
				}
			}
		}

		/*搜索框*/
		.el-input__suffix {
				cursor: pointer;
				line-height: 32px;
				padding-right: 10px;
				right:0;
				&:active{
					transform:scale(1.2);
				};
				.searchTableData {
					font-size: 16px;
				}

			}
	}
</style>


// WEBPACK FOOTER //
// src/components/subject/publicSiderbar.vue